import React from "react";
import PropTypes from "prop-types";

const FormField = ({ children, id, label, legend, fullWidth = false }) => {
  return (
    <fieldset className={fullWidth ? "full-width-field" : ""}>
      <div>
        <label htmlFor={id}>{label}</label>
        {fullWidth && <legend dangerouslySetInnerHTML={{ __html: legend }} />}
        {children}
      </div>

      {!fullWidth && (
        <div>
          <legend dangerouslySetInnerHTML={{ __html: legend }} />
        </div>
      )}
    </fieldset>
  );
};

FormField.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool
};

export default FormField;
